const importProducts = {
  list: {},
  create: {},
  details: {},
};
export default importProducts;
